import React from "react";
import { Card, Box, Typography } from "@mui/material";
import styles from "./zeroTrustKpiCard.module.scss";

const ZeroTrustKpiCard = ({
  icon,
  label,
  value,
  helper,
  accent,
  tone,
  iconBg,
  iconColor,
  showBar = false,
}) => (
  <Card className={styles.card}>
    <Box className={styles.header}>
      {icon ? (
        <Box
          className={styles.iconWrap}
          style={{ background: iconBg, color: iconColor }}
        >
          {icon}
        </Box>
      ) : null}
      <Typography className={styles.label}>{label}</Typography>
    </Box>
    <Typography
      className={styles.value}
      style={tone ? { color: tone } : undefined}
    >
      {value}
    </Typography>
    {helper ? <Typography className={styles.helper}>{helper}</Typography> : null}
    {showBar ? (
      <div className={styles.bar}>
        <span className={styles.fill} style={{ background: accent }} />
      </div>
    ) : null}
  </Card>
);

export default ZeroTrustKpiCard;
